import React from 'react';
import { Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const phoneNumber = '905327385437'; // WhatsApp number without spaces (Nurettin Bektaş)
  const callNumber = '902126553821'; // Main office number for calls (212) 655 38 21
  const message = 'Merhaba, Bektaş Temizlik hizmetleriniz hakkında bilgi almak istiyorum.'; // Default message

  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleCallClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(`tel:${callNumber}`, '_self');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Call Button */}
      <div 
        className="bg-blue-500 hover:bg-blue-600 text-white p-3 rounded-full shadow-lg cursor-pointer transition-colors duration-300 animate-bounce hover:animate-none"
        onClick={handleCallClick}
        title="Ara"
      >
        <Phone size={24} />
      </div>

      {/* WhatsApp Button */}
      <div 
        className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg cursor-pointer transition-colors duration-300 animate-bounce hover:animate-none"
        onClick={handleWhatsAppClick}
        title="WhatsApp'tan yazın"
      >
        <FaWhatsapp size={24} />
      </div>
    </div>
  );
};

export default WhatsAppButton;
